<template>
  <div class='lm-loop-close'>
    <h2>MoPaaS大模型 AI 加速闭环</h2>
    <div class="box">
      <div class="content">基于MoPaaS 大模型 AI 平台以及大模型应用引擎，MoPaaS 打造大模型 AI 应用加速业务闭环，全方位提供大模型人才培训、项目教练、应用共建、技术平台等产品和服务方案，协助合作伙伴低成本和高效率地加速大模型应用落地。欢迎高校、企业、政府、团队和个人使用或参与MoPaaS 大模型 AI 加速闭环产品和服务，共创大模型 AI 应用生态！</div>
      <img src="../../assets/images/lm-loop-h5.png"/>
    </div>
    </div>
</template>

<script>
export default {
  name: 'LmIntrodution'
}
</script>

<style>
.lm-loop-close {
  background: #F5F6F9;
  padding: 6vw 3vw;
}

.lm-loop-close h2 {
  margin: 0 auto 6vw;
  font-size: 16px;
  font-weight: 500;
  color: #3A3F4D;
  line-height: 20px;
}

.lm-loop-close .box {
  width: 100vw;
}

.lm-loop-close .box img {
  width: 94vw;
  height: 55vw;
  margin-top: 2vh;
}
.lm-loop-close .content {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  text-align: left;
  margin: 4vw 2vw 0;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/lm-loop-close.vue